// extracted by mini-css-extract-plugin
module.exports = {"JobPostContent":"styles_JobPostContent__lzvqa","height":"styles_height__SF4dq"};